import Search from '@/pages/search/Search.tsx';
import SearchB from '@/pages/search/SearchB.tsx';
import useAbType from '@/features/discover/hooks/useAbType.ts';
import { AbType } from '@/features/discover/types/types.ts';
import { ComponentType } from 'react';

const searchVariants: Record<AbType, ComponentType> = {
  A: Search,
  B: SearchB,
};

const SearchABRouter = () => {
  const abType = useAbType();

  if (!abType) return null;

  const Component = searchVariants[abType];
  return <Component />;
};

export default SearchABRouter;
